import { Route, Routes } from "react-router-dom"
import { w3cwebsocket as W3CWebSocket } from "websocket"
import Dashboard from "../views/Dashbord"
import NotFound from "../components/NotFound"
import Rules from "../views/rules/rules"
import AddRule from "../views/rules/addrule"
import ViewRule from "../views/rules/viewrules"
import Spaces from "../views/wokspaces/spaces"
import AddSpace from "../views/wokspaces/addspace"
import ViewSpace from "../views/wokspaces/viewspace"
import Profiles from "../views/profils/profils"
import AddProfil from "../views/profils/addprofil"
import ViewProfil from "../views/profils/viewprofil"
import Domains from "../views/domains/domains"
import AddDomaine from "../views/domains/adddomain"
import AddNomen from "../views/domains/addnomen"
import ViewDomaine from "../views/domains/Viewdomaine"
import Increments from "../views/increments/increments"
import Accounts from "../views/accounts/accounts"
import ViewAccount from "../views/accounts/viewaccount"
import Users from "../views/users/users"
import AddUser from "../views/users/adduser"
import ViewUser from "../views/users/viewuser"
import Connexions from "../views/connexions/connexions"
import ViewConnexion from "../views/connexions/viewconnexion"
import Clients from "../views/clients/clients"
import AddClient from "../views/clients/addclient"
import ViewClient from "../views/clients/wiewclient"
import Licences from "../views/licences/licences"
import AddLicence from "../views/licences/addlicence"
import ViewLicence from "../views/licences/viewlicence"
import Activities from "../views/operations/operations"
import ViewOparation from "../views/operations/viewoperation"
import ViewSession from "../views/sessions/sessionuser"
import { useEffect, useRef, useState } from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { config } from "../constants/config"
import SideBar2 from "../components/SideBar2"
import AbonnementsView from "../views/abonnements/abonnements"
import ViewAbonnements from "../views/abonnements/viewabonnement"
import ViewTypeAbonnements from "../views/abonnements/viewtypeabonnement"
import SitesView from "../views/sites/sites"
import ViewSites from "../views/sites/viewsite"
import HotspotsView from "../views/hotspots/hotsopts"
import ViewHotspots from "../views/hotspots/viewhotspot"
import ForfaitsView from "../views/forfaits/forfaits"
import ViewForfaits from "../views/forfaits/viewforfait"
import ViewTypeForfaits from "../views/forfaits/viewtypeforfait"
import SouscriptionsView from "../views/souscriptions/souscriptions"
import ViewAbonnementSouscrits from "../views/souscriptions/viewsouscriptionabonnement"
import ViewForfaitSouscrits from "../views/souscriptions/viewsouscriptionforfait"
import TransactionsView from "../views/transactions/transactions"
import ViewTransactions from "../views/transactions/viewtransaction"
import PubsView from "../views/pubs/pubs"
import ViewPubs from "../views/pubs/viewpub"
import MySouscriptionsView from "../views/souscriptions/mysous"
import RetraitsView from "../views/retraits/retraits"
import ViewRetraits from "../views/retraits/viewretrait"
import RevendeursView from "../views/revendeurs/revendeurs"
import ViewRevendeur from "../views/revendeurs/viewrevendeur"
import VpnsView from "../views/vpns/pubs"
import ViewVpns from "../views/vpns/viewpub"


const AppRoutes = () => {
    // states
    const [styl, setStyl] = useState("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion");
    const [ws, setWs] = useState(null);

    const audioRef = useRef(null);
    const sidebarRef = useRef();

    const playAudio = () => {
        if (audioRef.current) {
            audioRef.current.play();
        }
    };


    const changeStylelg = () => {
        if (styl === "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion") {
            setStyl("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggledlg")
        } else {
            setStyl("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion")
        }
    };

    const changeStylemd = () => {
        if (styl === "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion") {
            setStyl("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggledmd")
        } else {
            setStyl("navbar-nav bg-gradient-primary sidebar sidebar-dark accordion")
        }
    }

    // const handleSocketReact = () => {
    //     if (sidebarRef.current) {
    //         sidebarRef.current.childFunction();
    //         // playAudio();
    //     }
    // }

    // comportements
    // useEffect(() => {
    //     const client = new W3CWebSocket(`${config.socket.BASE_URL}`);
    //     setWs(client);

    //     client.onerror = () => {
    //         console.log("Error connexion");
    //     }

    //     client.onopen = () => {
    //         console.log(' client connected');
    //     }

    //     client.onmessage = (msg) => {
    //         console.log("msg websock received", msg);
    //         const data = JSON.parse(msg.data);
    //         console.log("date websock received", data);

    //         if (data.head) {
    //             handleSocketReact();
    //             // if (user?.isFullAction || user?.isFullActionNFC || user?.isGererAlarme) {
    //             //     let body = data?.body;
    //             //     if (body.codeemploye !== null) {
    //             //         showInfoMessage("New NFC employe to set exit!");
    //             //     } else {
    //             //         showInfoMessage("New QR code employe to set exit!");
    //             //     }
    //             //     setNbscan(nbscan + 1);
    //                 // playAudio();
    //             //     getAlarmlist();
    //             // }

    //         }
    //     }

    //     client.onclose = () => {
    //         console.log("User disconnected");
    //     }

    //     return () => {
    //         client.close();
    //     };

    // }, []);

    // affichages
    return (
        <div id="page-top">
            <div id="wrapper">
                <audio ref={audioRef} src="/assets/audio/notif1.mp3" />
                <SideBar2 ref={sidebarRef} styl={styl} changeStyle={changeStylelg} />
                {/* <SideBar styl={styl} changeStyle={changeStylelg} /> */}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header changeStyle={changeStylemd} />
                        <Routes>

                            <Route path="/" element={<Dashboard />} />

                            <Route path="/abonnements" element={<AbonnementsView />} />
                            <Route path='/abonnement/:code' element={<ViewAbonnements />} />
                            <Route path='/tabonnement/:code' element={<ViewTypeAbonnements />} />

                            <Route path="/sites" element={<SitesView />} />
                            <Route path='/site/:code' element={<ViewSites />} />

                            <Route path="/hotspots" element={<HotspotsView />} />
                            <Route path='/hotspot/:code' element={<ViewHotspots />} />

                            <Route path="/forfaits" element={<ForfaitsView />} />
                            <Route path='/forfait/:code' element={<ViewForfaits />} />
                            <Route path='/tforfait/:code' element={<ViewTypeForfaits />} />

                            <Route path="/souscriptions" element={<SouscriptionsView />} />
                            <Route path="/my-souscriptions" element={<MySouscriptionsView />} />
                            <Route path='/sous-forfait/:code' element={<ViewForfaitSouscrits />} />
                            <Route path='/sous-abonnement/:code' element={<ViewAbonnementSouscrits />} />

                            <Route path="/transactions" element={<TransactionsView />} />
                            <Route path='/transaction/:code' element={<ViewTransactions />} />

                            <Route path="/pubs" element={<PubsView />} />
                            <Route path='/pub/:code' element={<ViewPubs />} />

                            <Route path="/demandes-retrait" element={<RetraitsView />} />
                            <Route path='/demande-retrait/:code' element={<ViewRetraits />} />

                            <Route path="/revendeurs" element={<RevendeursView />} />
                            <Route path='/revendeur/:code' element={<ViewRevendeur />} />

                            <Route path="/vpns" element={<VpnsView />} />
                            <Route path='/vpn/:code' element={<ViewVpns />} />


                            {/* =========================== securite ============================== */}
                            <Route path="/rules" element={<Rules />} />
                            <Route path="/new-rule" element={<AddRule />} />
                            <Route path='/rule/:code' element={<ViewRule />} />

                            <Route path="/workspaces" element={<Spaces />} />
                            <Route path="/new-workspace" element={<AddSpace />} />
                            <Route path='/workspace/:code' element={<ViewSpace />} />

                            <Route path="/profiles" element={<Profiles />} />
                            <Route path="/new-profile" element={<AddProfil />} />
                            <Route path='/profile/:code' element={<ViewProfil />} />

                            <Route path="/domains" element={<Domains />} />
                            <Route path="/new-domain" element={<AddDomaine />} />
                            <Route path="/new-nomen/:table/:domain/:type" element={<AddNomen />} />
                            <Route path="/new-nomen/:table/:domain/:type/:parent" element={<AddNomen />} />
                            <Route path='/domain/:code' element={<ViewDomaine />} />

                            <Route path="/increments" element={<Increments />} />
                            {/* <Route path="/new-increment" element={<Dashboard />} />
                            <Route path='/increment/:code' element={<Dashboard />} /> */}

                            <Route path="/accounts" element={<Accounts />} />
                            {/* <Route path="/new-account" element={<Dashboard />} /> */}
                            <Route path='/account/:code' element={<ViewAccount />} />

                            <Route path="/users" element={<Users />} />
                            <Route path="/new-user" element={<AddUser />} />
                            <Route path='/user/:code' element={<ViewUser />} />

                            <Route path="/connexions" element={<Connexions />} />
                            {/* <Route path="/new-connexion" element={<Dashboard />} /> */}
                            <Route path='/connexion/:code' element={<ViewConnexion />} />

                            <Route path="/clients" element={<Clients />} />
                            <Route path="/new-client" element={<AddClient />} />
                            <Route path='/client/:code' element={<ViewClient />} />

                            <Route path="/licences" element={<Licences />} />
                            <Route path="/new-licence" element={<AddLicence />} />
                            <Route path='/licence/:code' element={<ViewLicence />} />

                            <Route path="/activites" element={<Activities />} />
                            <Route path='/activite/:code' element={<ViewOparation />} />

                            <Route path="/session" element={<ViewSession />} />


                            <Route path='*' element={<NotFound />} />
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </div>
    )
}

export default AppRoutes